import {
  Box,
  Card,
  Chip,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import { getEvidenceType } from "../../../common/EntitiesManagement";
import { CheckCircleOutlined, Delete, MoreHoriz } from "@mui/icons-material";
import localize from "../../../common/localize";
import FuseUtils from "../../../utils/FuseUtils";
import { EvidenceUploadStatusEnum } from "../../../common/utils";

export default function EvidenceItem({ item, onDeleteEvidence }) {
  const getStatusIcon = () => {
    switch (item.Status) {
      case EvidenceUploadStatusEnum.Pending:
        return (
          <MoreHoriz sx={{ height: "24px", width: "24px", color: "gray" }} />
        );
      case EvidenceUploadStatusEnum.Uploading:
        return <CircularProgress size={"1em"} sx={{ color: "darkblue" }} />;
      case EvidenceUploadStatusEnum.Succeeded:
        return (
          <CheckCircleOutlined
            sx={{ height: "24px", width: "24px", color: "green" }}
          />
        );
      case EvidenceUploadStatusEnum.Failed:
        return (
          <Tooltip label={item.Error ?? localize.error_unexpected}>
            <ErrorOutline
              sx={{ height: "24px", width: "24px", color: "red" }}
            />
          </Tooltip>
        );
    }
  };

  return (
    <Card
      variant="outlined"
      style={{ borderRadius: "5px" }}
      className="flex gap-2 w-full justify-bwtween p-2"
      key={FuseUtils.generateGUID()}
    >
      <Box className="w-full flex gap-2 items-center">
        {item.Status === 0 && onDeleteEvidence && (
          <IconButton onClick={onDeleteEvidence}>
            <Delete className="error_icon_color" />
          </IconButton>
        )}

        {item.Status > 0 && getStatusIcon()}

        <label className="text-xs">{item.Name}</label>
      </Box>

      <Box sx={{ width: "100px" }}>
        <Chip
          sx={{
            "& .MuiChip-deleteIcon": {
              color: "white",
            },
            "& .MuiChip-deleteIcon:hover": {
              color: "white",
            },
          }}
          style={{
            margin: "2px",
            fontSize: "12px",
            fontWeight: 400,
            backgroundColor: "#10366E",
            color: "white",
            width: "100%",
          }}
          label={getEvidenceType(item.EvidenceTypeId)}
        />
      </Box>
    </Card>
  );
}
